/* eslint-disable no-useless-catch */
import { serialize } from '../utils';
import { FindOneOptions } from './common';
import { entityService } from './services';
// #endregion Local Imports

const pathname = '/entity-document-categories';

export const EntityDocumentCategoryApi = {
  findOne: async (id: string, option: FindOneOptions) => {
    let url = `${pathname}/${id}`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findWithEntity: async (option: FilterEntityDocumentCategoryOption) => {
    let url = `${pathname}/find-with-entity`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  filter: async (option: FilterEntityDocumentCategoryOption) => {
    let url = `${pathname}/filter`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  create: async (body: CreateEntityDocumentCategoryBody) => {
    try {
      const response = await entityService.post(pathname, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  update: async (params: {
    id: string;
    body: UpdateEntityDocumentCategoryBody;
  }) => {
    const { id, body } = params;

    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.patch(url, body);

      return response;
    } catch (error) {
      throw error;
    }
  },

  remove: async (id: string) => {
    const url = `${pathname}/${id}`;
    try {
      const response = await entityService.delete(url);
      return response;
    } catch (error) {
      throw error;
    }
  },
};

export interface FilterEntityDocumentCategoryOption {
  page?: number;
  take?: number;
  skip?: number;
  reserved?: boolean;
  type?: number;
  name?: number;
  order?: any;
  entityID?: string;
  documentCategoryID?: string;
}

export interface CreateEntityDocumentCategoryBody {
  documentCategoryID: string;
  name?: string;
  description?: string;
}

export interface UpdateEntityDocumentCategoryBody {
  documentCategoryID: string;
  name?: string;
  description?: string;
  status?: number;
}
